import React from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Link as MuiLink,
} from "@mui/material";

const KthSoftLicTable = ({
  compareBy,
  handleCompareChange,
  ComparisonOptions,
  licenses,
}) => {
  return (
    <>
      <Grid container spacing={2} sx={{ my: 4 }}>
        <Grid item md={6} xs={12}>
          <FormControl fullWidth>
            <InputLabel id="compare-by-label">Compare Licenses By</InputLabel>
            <Select
              labelId="compare-by-label"
              id="compare-by"
              value={compareBy}
              label="Compare Licenses By"
              onChange={handleCompareChange}
            >
              {ComparisonOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>

      <TableContainer component={Paper} sx={{ mb: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>License</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Version</TableCell>
              <TableCell>
                {ComparisonOptions.find((opt) => opt.value === compareBy)
                  ?.label || "Feature"}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {licenses.map((license) => (
              <TableRow key={license.slug} hover>
                <TableCell>
                  <MuiLink
                    component={RouterLink}
                    to={`/software-licensing/${license.slug}`}
                    sx={{ textDecoration: "none", color: "#1976d2" }}
                  >
                    {license.name}
                  </MuiLink>
                </TableCell>
                <TableCell>{license.license_type}</TableCell>
                <TableCell>{license.version}</TableCell>
                <TableCell>
                  {typeof license[compareBy] === "boolean"
                    ? license[compareBy] === null
                      ? "No Data"
                      : license[compareBy]
                      ? "Yes"
                      : "No"
                    : license[compareBy] || "No Data"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default KthSoftLicTable;
